import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import BackArrow from '@common/images/back-arrow.svg';
import {Button} from '@learningblocks/shared-components/lib/Button' ;

import style from './style.module.scss';

const TRANSLATION_KEY = {
  Back: 'Back.string',
  BackAction: 'BackAction.string'
}

/**
 * CloseButton:
 *  - CloseButton for Modal Component
 */
export function CloseButton(props) {

  const { t } = useTranslation();

  const className = `${style.btn} ${props.className}_closeBtn`;

  return (
    <Button
      className={className}
      onClick={props.close}
      ariaLabel={t(TRANSLATION_KEY.BackAction)}
    >
      <img src={BackArrow} alt='' />
      <span>{t(TRANSLATION_KEY.Back)}</span>
    </Button>
  );
}

CloseButton.propTypes = {
  /**
   * custom className to set for closeButton
   */
  className: PropTypes.string.isRequired,
  /**
   * callback function to be involked close button is clicked
   */
  close: PropTypes.func,
  /**
   * String value to specify the size of modal
   */
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
};

CloseButton.defaultProps = {
  className: '',
  size: 'sm',
};
